export default {
    header: {
        heading: 'Communications',
        description: 'Configure the emails sent at each step of the cycle.',
    },
    blocks: {
        projectKickOff: { label: 'Project kick-off' },
        selfAssessmentLaunch: { label: 'Self-assessment launch' },
        feedback360Launch: { label: '360 feedback launch' },
        managerAssessmentLaunch: { label: '{{managerLabelCapitalized}} assessment launch' },
        managerDeadline: { label: '{{managerLabelCapitalized}} deadline' },
        discussionEmail: { label: 'Discussion email' },
        evaluationCycleClosure: { label: 'Feedback cycle closure' },
    },
    audience: {
        manager: 'For {{managerPluralLabel}}',
        employee: 'For employees',
    },
    email: {
        titleManager: 'Email for {{managerPluralLabel}}',
        titleEmployee: 'Email for employees',
        subjectLabel: 'Subject',
        subjectPlaceholder: 'Email subject',
        languageLabel: 'Language',
        sendTest: 'Send a test',
        disabledNotice: 'This email will not be sent.',
        enableAriaLabel: 'Enable the {{audience}} email',
        expandAriaLabel: 'Show email content',
        testSendUnavailable:
            'Test sending is not available yet for this email, it will be enabled once this milestone is fully wired.',
    },
    block: {
        enableAriaLabel: 'Enable the "{{title}}" block',
        disabledNotice: 'This milestone will still run, but no email will be sent.',
    },
};
